import Swiper, { Pagination } from 'swiper'

const contactsSliderInstances = [];
const contactsSliderElements = document.querySelectorAll('.contacts-slider');

if (contactsSliderElements.length) {
    for (let i = 0; i < contactsSliderElements.length; i++) {
        contactsSliderInstances[i] = {
            init: false,
            instance: null,
            element: contactsSliderElements[i],
        };
    }
}

function contactsSlidersInit() {
    if (contactsSliderInstances.length === 0) {
        return
    }

    for (let i = 0; i < contactsSliderElements.length; i++) {
        if (! contactsSliderInstances[i].init) {
            contactsSliderInstances[i].init = true;

            contactsSliderInstances[i].instance = initializeContentSlider(contactsSliderInstances[i].element, i % 2 === 0);
        }
    }
}
contactsSlidersInit();
window.addEventListener('resize', contactsSlidersInit);

function initializeContentSlider(slider) {
    const slides = slider.querySelectorAll('.swiper-slide');
    const titlePagination = slider.querySelectorAll('.pagination-titles');

    return new Swiper(slider, {
        modules: [ Pagination ],
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination, .swiper-pagination-custom',
            clickable: true,
            renderBullet: function(index, className) {
                if (0 === titlePagination.length) {
                    return '<span class="swiper-pagination-bullet"></span>';
                }

                const title = slides[index].getAttribute('data-title');
                return '<div class="' + className + '">' + title + '</div>';
            },
        },
    });
}
